import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const initialState = {
	minutes: dayjs().minute(),
	openReviewAlert: null
};

const myImagesSlice = createSlice(
	{
		name: 'myImages',
		initialState,
		reducers: {
			reloadMinutes(state) {
				state.minutes = dayjs().minute();
			},
			setOpenReviewAlert(state, { payload = false }) {
				state.openReviewAlert = payload;
			}
		}
	},
	initialState
);

export const { reloadMinutes, setOpenReviewAlert } = myImagesSlice.actions;

export default myImagesSlice.reducer;
